import { render } from "./BlogPostCreate.vue?vue&type=template&id=3e1822b0"
import script from "./BlogPostCreate.vue?vue&type=script&lang=js"
export * from "./BlogPostCreate.vue?vue&type=script&lang=js"
script.render = render

export default script